import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { SERVER_URL_TOKEN } from '@constants/diConstant';
import { HttpOptionsService } from './http-options.service';

/**
 * Базовый сервис для работы с HTTP АПИ.
 * Если вам нужно работать с АПИ:
 * 1. Не наследуйтесь от AppService
 * 2. Не копипастьте конструктор с SERVER_URL_TOKEN, и поля HttpClient и HttpOptionsService
 * 3. Используйте
 *    protected readonly http: BaseHttpService = inject(BaseHttpService);
 *    . . .
 *    this.http.client.post<any>(this.http.url + 'path', data, this.http.options)
 */
@Injectable({
    providedIn: 'root',
})
export class BaseHttpService {
    /** Базовый урл АПИ */
    readonly url = inject(SERVER_URL_TOKEN);

    /** HTTP запрос. */
    readonly client = inject(HttpClient);

    /** Сервис параметров запроса HTTP. */
    readonly options = inject(HttpOptionsService);
}
